<template>
  <Modal
    class="max-modal create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="actionText + '商品'"
    :width="850"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="130">
      <Row>
        <Col :sm="12" :xs="24">
          <FormItem label="商品类别:" prop="labelId">
            <Select v-model="handleForm.labelId" style="width: 100%;">
              <Option v-for="item in commodityCategory" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="供应商:" prop="supplierId">
            <Select v-model="handleForm.supplierId" style="width: 100%;" @on-change="changeSlect" @on-select="onSelect">
              <Option v-for="item in supplierList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="商品名称:" prop="commodityName">
            <Input v-model.trim="handleForm.commodityName" placeholder="请输入" maxlength="50" show-word-limit />
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="供应商商品:" prop="supplierCommodityName" >
            <Select
            v-model="handleForm.supplierCommodityName"
            style="width: 100%;"
            @on-change="supplierSlect"
            @on-open-change="supplierOpenSlect"
            >
              <Option v-for="item in commodityNameList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="成本折扣:" prop="costDiscount">
            <InputNumber
              style="width: 100%;"
              :max="120"
              :min="0"
              v-model="handleForm.costDiscount"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')" />
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="商品备注:" prop="remark">
            <Input v-model.trim="handleForm.remark" placeholder="请输入" maxlength="50" show-word-limit />
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="商品单价:" prop="facePrice">
            <InputNumber
              style="width: 100%;"
              :min="0"
              v-model="handleForm.facePrice"
              :formatter="value => `${value}元`"
              :parser="value => value.replace('元', '')" />
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="税点:" prop="taxPoint">
            <InputNumber
              style="width: 100%;"
              :max="20"
              :min="0"
              v-model="handleForm.taxPoint"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')" />
          </FormItem>
        </Col>
        <!-- 类型-->
        <Col :sm="12" :xs="24">
          <FormItem label="类型:" prop="marketingType">
            <Select v-model="handleForm.marketingType" style="width: 100%;">
              <Option v-for="item in types" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="12" :xs="24">
          <FormItem label="商品数量:" prop="couponNum">
            <InputNumber
              :min="1"
              style="width: 100%;"
              v-model="handleForm.couponNum"/>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="是否上架:" prop="useState">
            <iSwitch v-model.trim="handleForm.useState" :true-value="1" :false-value="0" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </iSwitch>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="是否短信通知:">
            <iSwitch v-model.trim="handleForm.sendSms" @on-change="changeSendSms" :true-value="1" :false-value="0" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </iSwitch>
            <Button v-if="handleForm.sendSms === 1" @click="showSmsModel" type="text">编辑</Button>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="商品图片:" prop="imageBase64">
            <Upload
              v-if="!handleForm.imageBase64"
              :show-upload-list="false"
              :before-upload="handleBeforeUpload"
              action="">
              <Button icon="md-cloud-upload">选择图片</Button>
            </Upload>
            <div v-else class="upload-image-view">
              <Icon type="md-close-circle" @click="deleteFile" />
              <img :src="handleForm.imageBase64" alt="">
            </div>
            <p class="upload-tips">支持的文件格式为：jpg, jpeg, png, gif，小于500K</p>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <editor ref="ue" v-model="handleForm.issueContent" height="300" :border="true" />
        </Col>
      </Row>
    </Form>
    <Modal v-model="showSmsTemplateModel" @on-cancel="handleSmsCancel" @on-ok="handleSmsOk"
           title="短信通知模版参数">
      <Form>
        <Row>
          <Col :sm="12" :xs="24">
            <FormItem label="t_name">
              <Input v-model.trim="smsTemplate.t_name" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col :sm="12" :xs="24">
            <FormItem label="t_content">
              <Input v-model.trim="smsTemplate.t_content" placeholder="请输入"/>
            </FormItem>
          </Col>
          <Col :sm="12" :xs="24">
            <FormItem label="t_time">
              <Input v-model.trim="smsTemplate.t_time" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col :sm="12" :xs="24">
            <FormItem label="t_where">
              <Input v-model.trim="smsTemplate.t_where" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col :sm="12" :xs="24">
            <FormItem label="t_use">
              <Input v-model.trim="smsTemplate.t_use" placeholder="请输入" />
            </FormItem>
          </Col>
        </Row>
      </Form>
      （权益到账提醒）尊敬的客户，您好！{{ smsTemplate.t_name || `{t_name}` }}已到账，内含{{ smsTemplate.t_content || '{t_content}' }}，
      请于{{ smsTemplate.t_time || '{t_time}' }}使用，过期失效，不做补发。查看方式：{{ smsTemplate.t_where || '{t_where}' }}。使用方式：{{ smsTemplate.t_use || '{t_use}' }}。
    </Modal>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import api from '../../api'
import utils from '../../utils'
import Editor from "@/components/Editor.vue";

export default {
  name: 'CommodityCreateUpdate',
  components: {Editor},
  data () {
    return {
      smsTemplate: {
        't_name': '',
        't_content': '',
        't_time': '',
        't_where': '',
        't_use': ''
      },
      modal: false,
      loading: false,
      action: 'create',
      dataIndex: null,
      file: null,
      typesId: null,
      startSupplist: {},
      types: [
        {
          value: 0,
          label: '实时订购'
        },
        {
          value: 1,
          label: '库存商品'
        }
      ],
      handleForm: {
        couponNum: 1,
        commodityId: '', // 商品id
        commodityName: '', // 商品名称
        imageBase64: null, // 商品图片
        issueContent: '',
        labelId: '', // 商品分类id
        // costPrice: 0, // 成本价
        costDiscount: 0, // 成本折扣
        facePrice: 0, // 商品单价
        taxPoint: 0, // 税点
        useState: 0, // 上下架
        marketingType: '', // 类型
        remark: '', // 备注
        // startDate: null,
        // updateDate: null,
        supplierId: '', // 供应商id
        // supplierCommodityNo: '', // 供应商商品id
        supplierCommodityName: '', // 供应商商品名称
        smsTemplate: '',
        sendSms: 0
      },
      showSmsTemplateModel: false,
      handleValidate: {
        labelId: [
          { required: true, whitespace: true, message: '请选择商品类别', trigger: 'change' }
        ],
        commodityName: [
          { required: true, whitespace: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        supplierId: [
          { required: true, whitespace: true, message: '请选择供应商', trigger: 'change' }
        ],
        supplierCommodityName: [
          { required: true, whitespace: true, message: '请输入供应商商品名称', trigger: 'change' }
        ],
        marketingType: [
          { required: true, whitespace: true, type: 'number', message: '请选择类型', trigger: 'change' }
        ],
        costDiscount: [
          { required: true, whitespace: true, type: 'number', message: '请输入销售折扣', trigger: 'blur' }
        ],
        facePrice: [
          { required: true, whitespace: true, type: 'number', message: '请输入商品单价', trigger: 'blur' }
        ],
        taxPoint: [
          { required: true, whitespace: true, type: 'number', message: '请输入税点', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    },
    ...mapGetters('commodity', ['commodityCategory', 'commodityNameList']),
    ...mapGetters('supplier', ['supplierList'])
  },
  // watch: {
  //   commodityNameList: {
  //     handler (newName, oldName) {
  //       if (newName.length === 0) {
  //         this.$Message.warning('请重新选择供应商，该供应商下无商品')
  //         this.supplierCommodityName = ''
  //       }
  //     }
  //     // immediate: true
  //   }
  // },
  methods: {
    handleSmsOk () {
      this.handleForm.smsTemplate = JSON.stringify(this.smsTemplate)
      this.smsTemplate = {
        't_name': '',
        't_content': '',
        't_time': '',
        't_where': '',
        't_use': ''
      }
    },
    handleSmsCancel () {
      this.handleForm.sendSms = 0
      this.handleForm.smsTemplate = ''
      this.smsTemplate = {
        't_name': '',
        't_content': '',
        't_time': '',
        't_where': '',
        't_use': ''
      }
    },
    showSmsModel () {
      let { smsTemplate } = this.handleForm
      if (smsTemplate) {
        this.smsTemplate = JSON.parse(smsTemplate)
      }
      this.showSmsTemplateModel = true
    },
    changeSendSms (e) {
      let { sendSms } = this.handleForm
      if (sendSms !== 1) {
        this.handleForm.smsTemplate = ''
        return
      }
      this.showSmsModel()
    },
    // 选择判断
    changeSlect (value) {
      if (value) {
        this.getCommodityNameList({
          supplierId: value,
          pageNum: 1,
          pageSize: 1000,
          sourceType: 1,
          useState: 1
        })
      }
    },
    onSelect (e) {
      this.handleForm.supplierCommodityName = ''
    },
    //  拿到对应的商品
    supplierSlect (e) {
      let index = this.commodityNameList.find(item => item.value === e)
      this.startSupplist = {
        couponType: index?.couponType,
        costPrice: index?.costPrice,
        supplierCommodityNo: index?.supplierCommodityNo
      }
    },
    // 提示先选择供应商才能选择供应商商品
    supplierOpenSlect (e) {
      if (e && !this.handleForm.supplierId) {
        this.$Message.warning('请先选择供应商')
      }
      // if (e && this.commodityNameList.length === 0 && this.handleForm.supplierId !== '') {
      //   this.$Message.warning('请重新选择供应商，该供应商下无商品')
      // }
    },
    ...mapActions('commodity', ['getCommodityNameList']),
    async show (action = 'create', data = {}, index) {
      this.action = action
      if (this.action === 'update') {
        await this.getCommodityNameList({
          supplierId: data.supplierId,
          pageNum: 1,
          pageSize: 1000,
          sourceType: 1,
          useState: 1
        })
        this.handleForm = {
          commodityId: data.id,
          couponNum: data.couponNum,
          commodityName: data.commodityName,
          imageBase64: data.imageBase64,
          labelId: data.labelId,
          costDiscount: data.costDiscount,
          facePrice: data.facePrice,
          taxPoint: data.taxPoint,
          marketingType: data.marketingType,
          useState: data.useState,
          remark: data.remark,
          issueContent: data.issueContent,
          supplierId: data.supplierId,
          supplierCommodityName: data.supplierCommodityName,
          sendSms: data.sendSms,
          smsTemplate: data.smsTemplate
        }
        this.startSupplist = {
          costPrice: data.costPrice,
          supplierCommodityNo: data.supplierCommodityNo,
          couponType: data.couponType
        }
        this.dataIndex = index
      }
      this.modal = true
    },

    hide () {
      this.$refs['handleForm'].resetFields()
      this.handleForm.commodityId = ''
      this.handleForm.supplierCommodityName = ''
      this.dataIndex = null
      this.loading = false
      this.modal = false
      this.$store.commit('commodity/updateCommodityNameList', [])
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        // console.log(valid)
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      // console.log(this.startSupplist)
      let queryParams = {
        ...this.handleForm,
        ...this.startSupplist,
        sourceType: 0
      }
      let submitApi = api.commodity.commodityCreateUpdate
      if (this.action === 'create') {
        delete queryParams.commodityId
      }
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error(this.actionText + '失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    },
    handleBeforeUpload (file) {
      const format = ['image/jpeg', 'image/png', 'image/gif']
      const maxSize = 500 * 1024 // 500k
      const fileSize = file.size
      const fileType = file.type
      if (format.indexOf(fileType) === -1) {
        this.handleFormatError()
      } else if (fileSize > maxSize) {
        this.handleMaxSize()
      } else {
        this.file = file
        utils.readFile(file).then(content => {
          this.handleForm.imageBase64 = content
        })
      }
      return false
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式错误',
        desc: '文件格式不正确，请重新选择！'
      })
    },
    handleMaxSize () {
      this.$Notice.warning({
        title: '文件超过大小限制',
        desc: '文件超过规定的大小限制，请检查！'
      })
    },
    deleteFile () {
      this.file = null
      this.handleForm.imageBase64 = ''
    }
  }
}
</script>
<style lang="less">
 .ivu-notice {
  margin-right: calc(50% - 170px);
}
</style>
